/****************************************************************************
 ** @license
 ** This demo file is part of yFiles for HTML 2.4.0.3.
 ** Copyright (c) 2000-2021 by yWorks GmbH, Vor dem Kreuzberg 28,
 ** 72070 Tuebingen, Germany. All rights reserved.
 **
 ** yFiles demo files exhibit yFiles for HTML functionalities. Any redistribution
 ** of demo files in source code or binary form, with or without
 ** modification, is not permitted.
 **
 ** Owners of a valid software license for a yFiles for HTML version that this
 ** demo is shipped with are allowed to use the demo source code as basis
 ** for their own yFiles for HTML powered applications. Use of such programs is
 ** governed by the rights and conditions as set out in the yFiles for HTML
 ** license agreement.
 **
 ** THIS SOFTWARE IS PROVIDED ''AS IS'' AND ANY EXPRESS OR IMPLIED
 ** WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 ** MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN
 ** NO EVENT SHALL yWorks BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 ** SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED
 ** TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 ** PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 ** LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 ** NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 ** SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 **
 ***************************************************************************/
// @ts-ignore
import { NodeTypeName } from 'enumerations/nodetype-name'
import { Component } from 'react'
interface ItemElementProps {
  width: number
  height: number
  tag: { name?: string, typeName: string, receiveMessageType: string, sendMessageType: string, system: boolean, stopped: boolean}
}

export default class NodeTemplate extends Component<ItemElementProps> {

  render(): JSX.Element {
    const lockOutlinedIcon = 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z';
    const accessTimeIcon1 = "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z";
    const accessTimeIcon2 = "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z";
    const callSplitIcon = "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z";
    const settingsIcon = "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z";
    const filesDotComIcon1 = "M57.316 104.472V75.499a1.411 1.411 0 00-2.409-.998l-28.972 28.973a1.41 1.41 0 00.997 2.41h28.973a1.411 1.411 0 001.411-1.412z";
    const filesDotComIcon2 = "M85.123 93.198L66.419 74.494a1.413 1.413 0 00-2.41.998v37.407a1.413 1.413 0 002.41.998l18.704-18.704a1.412 1.412 0 000-1.995zM70.897 61.961h38.089a1.413 1.413 0 00.998-2.41L90.939 40.507a1.414 1.414 0 00-1.999 0L69.896 59.55a1.412 1.412 0 001 2.41z";
    const filesDotComIcon3 = "M64.017 23.605v30.381a1.411 1.411 0 002.41.998l30.38-30.381a1.413 1.413 0 00-.998-2.41H65.43a1.412 1.412 0 00-1.412 1.412z";
    const filesDotComIcon4 = "M15.468 26.992V60.55a1.412 1.412 0 001.412 1.412h33.556a1.411 1.411 0 00.998-2.41l-33.56-33.553a1.412 1.412 0 00-2.406.994z";
    const filesDotComIcon5 = "M69.896 69.965l21.55 21.55a1.412 1.412 0 002.409-.998V68.982a1.413 1.413 0 00-1.412-1.412H70.897a1.412 1.412 0 00-1.001 2.395zM50.436 67.57H1.396a1.412 1.412 0 00-.998 2.395l24.52 24.52a1.41 1.41 0 002 0l24.516-24.52a1.412 1.412 0 00-.998-2.395zM28.615 28.7l26.3 26.287a1.412 1.412 0 002.409-.997V1.41a1.411 1.411 0 00-2.41-.997L28.615 26.69a1.413 1.413 0 000 2.01z";
    const webhooksIcon1 = "M119.54 100.503c-10.61 17.836-20.775 35.108-31.152 52.25-2.665 4.401-3.984 7.986-1.855 13.58 5.878 15.454-2.414 30.493-17.998 34.575-14.697 3.851-29.016-5.808-31.932-21.543-2.584-13.927 8.224-27.58 23.58-29.757 1.286-.184 2.6-.205 4.762-.367l23.358-39.168C73.612 95.465 64.868 78.39 66.803 57.23c1.368-14.957 7.25-27.883 18-38.477 20.59-20.288 52.002-23.573 76.246-8.001 23.284 14.958 33.948 44.094 24.858 69.031-6.854-1.858-13.756-3.732-21.343-5.79 2.854-13.865.743-26.315-8.608-36.981-6.178-7.042-14.106-10.733-23.12-12.093-18.072-2.73-35.815 8.88-41.08 26.618-5.976 20.13 3.069 36.575 27.784 48.967z";
    const webhooksIcon2 = "M149.841 79.41c7.475 13.187 15.065 26.573 22.587 39.836 38.02-11.763 66.686 9.284 76.97 31.817 12.422 27.219 3.93 59.457-20.465 76.25-25.04 17.238-56.707 14.293-78.892-7.851 5.654-4.733 11.336-9.487 17.407-14.566 21.912 14.192 41.077 13.524 55.305-3.282 12.133-14.337 11.87-35.714-.615-49.75-14.408-16.197-33.707-16.691-57.035-1.143-9.677-17.168-19.522-34.199-28.893-51.491-3.16-5.828-6.648-9.21-13.77-10.443-11.893-2.062-19.571-12.275-20.032-23.717-.453-11.316 6.214-21.545 16.634-25.53 10.322-3.949 22.435-.762 29.378 8.014 5.674 7.17 7.477 15.24 4.491 24.083-.83 2.466-1.905 4.852-3.07 7.774z";
    const webhooksIcon3 = "M167.707 187.21h-45.77c-4.387 18.044-13.863 32.612-30.19 41.876-12.693 7.2-26.373 9.641-40.933 7.29-26.808-4.323-48.728-28.456-50.658-55.63-2.184-30.784 18.975-58.147 47.178-64.293 1.947 7.071 3.915 14.21 5.862 21.264-25.876 13.202-34.832 29.836-27.59 50.636 6.375 18.304 24.484 28.337 44.147 24.457 20.08-3.962 30.204-20.65 28.968-47.432 19.036 0 38.088-.197 57.126.097 7.434.117 13.173-.654 18.773-7.208 9.22-10.784 26.191-9.811 36.121.374 10.148 10.409 9.662 27.157-1.077 37.127-10.361 9.62-26.73 9.106-36.424-1.26-1.992-2.136-3.562-4.673-5.533-7.298z";
    const loadBalancerIcon = "M 149.5,23.5 C 152.862,23.0695 155.695,24.0695 158,26.5C 164.61,38.382 170.11,50.7153 174.5,63.5C 173.401,70.4328 169.401,73.2662 162.5,72C 160.714,71.2155 159.214,70.0488 158,68.5C 156.421,65.0061 154.587,61.6728 152.5,58.5C 148.074,68.6114 144.574,78.9447 142,89.5C 150.877,95.0959 156.71,102.929 159.5,113C 170.5,113.667 181.5,113.667 192.5,113C 187.635,108.914 184.302,103.914 182.5,98C 183.727,91.3757 187.727,88.7091 194.5,90C 204.304,98.8029 213.804,107.97 223,117.5C 225,120.5 225,123.5 223,126.5C 214.864,135.637 206.364,144.47 197.5,153C 192.599,156.487 188.099,155.987 184,151.5C 182.543,148.634 182.21,145.634 183,142.5C 185.797,138.701 188.964,135.201 192.5,132C 181.257,131.18 170.09,131.347 159,132.5C 155.458,142.102 149.625,149.936 141.5,156C 144.557,166.511 148.391,176.678 153,186.5C 154.598,181.468 157.098,176.968 160.5,173C 164.295,172.163 167.961,172.496 171.5,174C 173.444,175.722 174.444,177.889 174.5,180.5C 170.171,192.828 165.004,204.828 159,216.5C 157.367,219.148 155.033,220.481 152,220.5C 138.726,216.197 126.06,210.53 114,203.5C 111.585,198.564 112.085,194.064 115.5,190C 122.18,187.895 128.347,189.062 134,193.5C 131.302,183.069 127.969,172.736 124,162.5C 123.481,161.484 122.647,160.818 121.5,160.5C 102.492,158.819 90.4918,148.819 85.5,130.5C 79.7945,130.171 74.1278,130.505 68.5,131.5C 62.565,142.88 53.2317,147.047 40.5,144C 25.9902,137.466 21.4902,126.633 27,111.5C 35.6113,98.9495 46.778,96.1162 60.5,103C 64.2565,106.086 67.2565,109.752 69.5,114C 74.5,114.667 79.5,114.667 84.5,114C 90.6953,95.8049 103.362,85.8049 122.5,84C 127.338,73.3149 131.005,62.4816 133.5,51.5C 129.39,53.3051 125.223,54.9717 121,56.5C 113.285,54.7741 110.619,50.1074 113,42.5C 124.709,35.2294 136.875,28.8961 149.5,23.5 Z M 118.5,100.5 C 136.823,100.988 144.99,110.322 143,128.5C 134.641,144.507 122.808,147.674 107.5,138C 97.762,126.361 98.4287,115.361 109.5,105C 112.324,102.921 115.324,101.421 118.5,100.5 Z";
    const nodeRunningIcon1 = "M2655 4749 l-20 -114 -160 -6 c-515 -21 -982 -222 -1354 -583 -162 -158 -287 -324 -390 -518 -50 -94 -121 -257 -121 -278 0 -7 75 61 167 149 92 89 170 161 174 161 3 0 50 -92 105 -205 54 -113 101 -205 104 -205 3 1 27 45 53 98 225 455 703 778 1219 821 51 4 95 6 97 4 3 -2 -5 -58 -17 -125 -11 -68 -20 -123 -19 -124 1 -1 38 16 82 37 44 21 224 108 400 193 175 84 320 157 322 162 1 5 -138 152 -310 328 l-312 319 -20 -114z";
    const nodeRunningIcon2 = "M3394 4348 c91 -95 166 -175 166 -179 0 -3 -93 -51 -206 -105 l-207 -100 104 -52 c281 -142 515 -373 658 -651 100 -196 156 -389 168 -582 l6 -96 -128 23 c-71 13 -129 23 -130 21 -5 -5 383 -801 391 -804 5 -1 153 139 329 311 l319 313 -112 18 -112 18 0 104 c0 818 -526 1584 -1304 1897 -49 20 -93 36 -98 36 -5 0 65 -77 156 -172z";
    const nodeRunningIcon3 = "M576 2987 l-318 -312 113 -20 114 -20 7 -160 c3 -88 16 -212 27 -275 114 -645 517 -1191 1102 -1490 94 -48 260 -120 277 -120 2 0 -73 80 -167 177 -94 97 -171 180 -171 183 0 4 92 51 205 105 l205 99 -98 51 c-154 81 -247 150 -377 280 -216 216 -343 443 -411 735 -31 134 -44 310 -22 310 8 0 64 -9 123 -20 60 -10 110 -18 111 -17 4 5 -384 801 -392 804 -5 1 -152 -138 -328 -310z";
    const nodeRunningIcon4 = "M3929 1888 c-101 -213 -315 -459 -514 -591 -227 -150 -479 -237 -731 -253 l-101 -7 23 129 c13 70 22 129 21 130 -5 4 -802 -385 -804 -393 -1 -4 139 -152 311 -328 l313 -319 18 112 18 112 106 0 c755 1 1473 446 1824 1131 51 100 117 258 117 281 0 5 -80 -67 -177 -161 -97 -94 -179 -171 -183 -171 -4 0 -50 90 -103 200 -53 110 -98 200 -100 200 -2 0 -19 -33 -38 -72z";
    const nodeStoppedIcon = "M3525 7639 c-420 -38 -829 -142 -1205 -304 -877 -379 -1596 -1098 -1975 -1975 -209 -483 -315 -996 -315 -1520 0 -1113 480 -2159 1325 -2889 487 -421 1080 -713 1705 -841 293 -60 444 -74 780 -74 336 0 487 14 780 74 624 128 1218 421 1705 841 639 552 1079 1297 1245 2109 60 293 74 444 74 780 0 336 -14 487 -74 780 -248 1212 -1096 2244 -2240 2727 -346 147 -679 234 -1080 283 -116 15 -602 21 -725 9z m625 -800 c421 -42 853 -185 1228 -407 97 -58 256 -164 284 -191 4 -3 -943 -957 -2105 -2119 l-2113 -2113 -63 88 c-293 411 -481 909 -542 1433 -16 144 -13 492 6 655 79 677 383 1305 864 1786 643 642 1533 959 2441 868z m2155 -1264 c233 -326 408 -737 494 -1155 72 -351 71 -809 -4 -1174 -70 -347 -213 -707 -400 -1006 -434 -695 -1151 -1191 -1961 -1355 -367 -75 -821 -76 -1174 -4 -422 86 -828 261 -1163 500 l-88 63 2113 2113 c1162 1162 2116 2109 2119 2105 4 -4 33 -43 64 -87z";
    const websubIcon1 = "M 27.5,42.5 C 52.5,42.5 77.5,42.5 102.5,42.5C 102.5,67.5 102.5,92.5 102.5,117.5C 77.5,117.5 52.5,117.5 27.5,117.5C 27.5,92.5 27.5,67.5 27.5,42.5 Z";
    const websubIcon2 = "M 139.5,42.5 C 152.186,40.6039 163.853,43.1039 174.5,50C 183.199,58.0932 187.199,68.0932 186.5,80C 187.41,97.0805 180.076,109.081 164.5,116C 154.167,118 143.833,118 133.5,116C 117.924,109.081 110.59,97.0805 111.5,80C 111.292,60.2067 120.626,47.7067 139.5,42.5 Z";
    const websubIcon3 = "M 196.5,42.5 C 221.167,42.5 245.833,42.5 270.5,42.5C 270.5,67.5 270.5,92.5 270.5,117.5C 245.5,117.5 220.5,117.5 195.5,117.5C 195.177,92.4255 195.51,67.4255 196.5,42.5 Z";


    let color = '#666';
    if (this.props && this.props.tag && this.props.tag && this.props.tag.typeName) {
      const tp = this.props.tag.typeName;
      if (tp === NodeTypeName.BitmapRouterNode) {
        color = '#909070';
      } else if (tp === NodeTypeName.ProcessorNode) {
        color = '#A09070';
      } else if (tp === NodeTypeName.TimerNode) {
        color = '#509070';
      } else if (tp === NodeTypeName.CrossTenantSendingNode) {
        color = '#808070';
      } else if (tp === NodeTypeName.CrossTenantReceivingNode) {
        color = '#807080';
      } else if (tp === NodeTypeName.AppChangeReceiverNode) {
        color = '#666';
      } else if (tp === NodeTypeName.ManagedNode) {
        color = '#90A0A0';
      } else if (tp === NodeTypeName.ExternalNode) {
        color = '#708090';
      } else if (tp === NodeTypeName.FilesDotComWebhookNode || tp === NodeTypeName.WebhookNode) {
        color = '#5F7B89'
      } else if (tp === NodeTypeName.LoadBalancerNode) {
        color = '#C37D28'
      } else if (tp === NodeTypeName.WebSubHubNode) {
        color = '#005c5e'
      }
    }

    return (
      <g>
        <defs>
          <filter id="f3" x="0" y="0" width={this.props.width} height={this.props.height}>
            <feOffset result="offOut" in="SourceAlpha" dx="5" dy="5" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
          <filter x="0" y="0" width="1" height="1" id="solid">
            <feFlood floodColor="#333" result="bg" />
            <feMerge>
              <feMergeNode in="bg" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <rect
          style={{ fill: '#DDD' }}
          x={0}
          y={0}
          rx={4}
          ry={4}
          width={this.props.width}
          height={this.props.height}
          filter={`url(#f3)`}
        />
        <rect
          style={{ fill: color }}
          x={2}
          y={2}
          rx={4}
          ry={4}
          width={this.props.width - 4}
          height={this.props.height - 4}
        />
        <text
          x={this.props.width / 2}
          y={this.props.height / 2}
          fontSize={12}
          style={{ fill: '#ffffff', textAnchor: 'middle', dominantBaseline: 'middle' }}
        >
          {this.props && this.props.tag && this.props.tag && this.props.tag.name}
        </text>
        <text
          x={this.props.width / 2}
          y={(this.props.height + 22) / 2}
          fontSize={9}
          style={{ fill: '#ccc', textAnchor: 'middle', dominantBaseline: 'middle' }}
        >
          {this.props && this.props.tag && this.props.tag && this.props.tag.typeName}
        </text>
        {this.props && this.props.tag && this.props.tag && this.props.tag.receiveMessageType && <text
          x={30}
          y={(this.props.height - 35) / 2}
          fontSize={9}
          filter={`url(#solid)`}
          style={{ fill: '#ccc', textAnchor: 'middle', dominantBaseline: 'middle' }}>
          {this.props.tag.receiveMessageType}
        </text>}
        {this.props && this.props.tag && this.props.tag && this.props.tag.sendMessageType && <text
          x={this.props.width - 30}
          y={(this.props.height - 35) / 2}
          fontSize={9}
          filter={`url(#solid)`}
          style={{ fill: '#ccc', textAnchor: 'middle', dominantBaseline: 'middle' }}>
          {this.props.tag.sendMessageType}
        </text>}
        {this.props && this.props.tag && this.props.tag && this.props.tag.system &&
          <g transform={`scale(0.75 0.75) translate(${(this.props.width - 20) / 0.75}, ${(this.props.height - 20) / 0.75})`} >
            <path fill={'#DDD'} d={lockOutlinedIcon} />
          </g>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === NodeTypeName.TimerNode &&
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
            :
            <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
                <path fill={'#07bc0c'} d={nodeRunningIcon1} />
                <path fill={'#07bc0c'} d={nodeRunningIcon2} />
                <path fill={'#07bc0c'} d={nodeRunningIcon3} />
                <path fill={'#07bc0c'} d={nodeRunningIcon4} />
              </g>
            }
          <g transform={`scale(0.75 0.75) translate(${(this.props.width - 20) / 0.75}, ${(this.props.height - 20) / 0.75})`} >
            <path fill={'#DDD'} d={accessTimeIcon1} />
            <path fill={'#DDD'} d={accessTimeIcon2} />
          </g>
          </>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === NodeTypeName.BitmapRouterNode &&
          <>
            {this.props.tag.stopped ? 
              <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
                <path fill={'#ff1800'} d={nodeStoppedIcon}/>
              </g>
            :
            <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
                <path fill={'#07bc0c'} d={nodeRunningIcon1} />
                <path fill={'#07bc0c'} d={nodeRunningIcon2} />
                <path fill={'#07bc0c'} d={nodeRunningIcon3} />
                <path fill={'#07bc0c'} d={nodeRunningIcon4} />
              </g>
            }
          <g transform={`scale(0.75 0.75) translate(${(this.props.width - 20) / 0.75}, ${(this.props.height - 20) / 0.75})`} >
            <path fill={'#DDD'} d={callSplitIcon} />
          </g>
        </>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === NodeTypeName.ProcessorNode &&
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
          :
            <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
              <path fill={'#07bc0c'} d={nodeRunningIcon1} />
              <path fill={'#07bc0c'} d={nodeRunningIcon2} />
              <path fill={'#07bc0c'} d={nodeRunningIcon3} />
              <path fill={'#07bc0c'} d={nodeRunningIcon4} />
            </g>
              }
            <g transform={`scale(0.75 0.75) translate(${(this.props.width - 20) / 0.75}, ${(this.props.height - 20) / 0.75})`} >
              <path fill={'#DDD'} d={settingsIcon} />
            </g>
          </>
          }
        {this.props && this.props.tag && this.props.tag.typeName === NodeTypeName.FilesDotComWebhookNode &&
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
            :
            <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
              <path fill={'#07bc0c'} d={nodeRunningIcon1} />
              <path fill={'#07bc0c'} d={nodeRunningIcon2} />
              <path fill={'#07bc0c'} d={nodeRunningIcon3} />
              <path fill={'#07bc0c'} d={nodeRunningIcon4} />
            </g>
              }
          <g transform={`scale(0.15 0.15) translate(${(this.props.width - 20) / 0.15}, ${(this.props.height - 20) / 0.15})`} >
            <path fill={'#D6C7C7'} d={filesDotComIcon1} />
            <path fill={'#B8A8A8'} d={filesDotComIcon2} />
            <path fill={'#D6C7C7'} d={filesDotComIcon3} />
            <path fill={'#B8A8A8'} d={filesDotComIcon4} />
            <path fill={'#EBDDDD'} d={filesDotComIcon5} />
          </g>
          </>
        }
        {this.props && this.props.tag && this.props.tag.typeName === NodeTypeName.WebhookNode &&
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
          :
          <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
              <path fill={'#07bc0c'} d={nodeRunningIcon1} />
              <path fill={'#07bc0c'} d={nodeRunningIcon2} />
              <path fill={'#07bc0c'} d={nodeRunningIcon3} />
              <path fill={'#07bc0c'} d={nodeRunningIcon4} />
            </g>
              }
            <g transform={`scale(0.07 0.07) translate(${(this.props.width - 20) / 0.071}, ${(this.props.height - 20) / 0.075})`} >
              <path fill={'#DDD'} d={webhooksIcon1} />
              <path fill={'#DDD'} d={webhooksIcon2} />
              <path fill={'#DDD'} d={webhooksIcon3} />
            </g>
            </>
        }
        {this.props && this.props.tag && this.props.tag.typeName === NodeTypeName.WebSubHubNode &&
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
          :
          <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
              <path fill={'#07bc0c'} d={nodeRunningIcon1} />
              <path fill={'#07bc0c'} d={nodeRunningIcon2} />
              <path fill={'#07bc0c'} d={nodeRunningIcon3} />
              <path fill={'#07bc0c'} d={nodeRunningIcon4} />
            </g>
              }
            <g transform={`scale(0.07 0.07) translate(${(this.props.width - 20) / 0.071}, ${(this.props.height - 11) / 0.075})`} >
              <path fill={'#ccc'} d={websubIcon1} />
              <path fill={'#ccc'} d={websubIcon2} />
              <path fill={'#ccc'} d={websubIcon3} />
            </g>
            </>
        }
        {this.props && this.props.tag && this.props.tag && this.props.tag.typeName === NodeTypeName.LoadBalancerNode &&    
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
              :
              <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
                <path fill={'#07bc0c'} d={nodeRunningIcon1} />
                <path fill={'#07bc0c'} d={nodeRunningIcon2} />
                <path fill={'#07bc0c'} d={nodeRunningIcon3} />
                <path fill={'#07bc0c'} d={nodeRunningIcon4} />
              </g>
              }
            <g transform={`scale(0.09 0.09) translate(${(this.props.width - 20) / 0.092}, ${(this.props.height - 20) / 0.1})`} >
              <path fillRule={'evenodd'} fill={'#DDD'} d={loadBalancerIcon} />
            </g>
            </>
        }
        {this.props && this.props.tag && this.props.tag && (this.props.tag.typeName === NodeTypeName.ExternalNode || this.props.tag.typeName === NodeTypeName.ManagedNode || this.props.tag.typeName === NodeTypeName.CrossTenantReceivingNode || this.props.tag.typeName === NodeTypeName.CrossTenantSendingNode) && 
        <>
          {this.props.tag.stopped ? 
            <g transform={`scale(0.0016 0.0016) translate(2300, 27500)`} stroke="none">
              <path fill={'#ff1800'} d={nodeStoppedIcon}/>
            </g>
          :
          <g transform={`scale(0.003 0.003) translate(850, 14000)`} >
            <path fill={'#07bc0c'} d={nodeRunningIcon1} />
              <path fill={'#07bc0c'} d={nodeRunningIcon2} />
              <path fill={'#07bc0c'} d={nodeRunningIcon3} />
              <path fill={'#07bc0c'} d={nodeRunningIcon4} />
            </g>
        }
          </>
          }
      </g>
    )
  }
}
